module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pt2",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "PT",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Baruta_Black_B_17"
  }, [_vm._v("EXPLORING WATERCOLOR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Intro"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("I have always found watercolor magical. It’s a versatile medium that allows you to work fast if you’re aiming for a fresh take, or paint more slowly, working layer by layer to achieve beautifully detailed images. Watercolor can be playful, unpredictable, surprising, and whimsical. It requires a little practice to understand and learn the qualities of the paint, but once you start to grasp its magic, I’m sure you’ll fall in love with it, too!")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "249",
      "src": "images/pg12-1.jpg",
      "width": "246"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f068acd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2.vue
// module id = 75
// module chunks = 0